<template>
  <div class="controls">
    <button @click="start" class="button">
      <div class="dashicons dashicons-format-video" />
    </button>
    <div class="modal videoModal" ref="modal" v-show="playing">
      <div class="image">
        <video
          v-if="loaded"
          :src="medium.src"
          ref="player"
          @ended="onEnded"
          @play="onPlay"
          controls
        />
      </div>
      <div class="scrim" @click="stop" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    playing: false,
    loaded: false
  }),
  props: {
    medium: Object
  },
  methods: {
    start() {
      this.loaded = true
      process.nextTick(() => {
        this.$refs.player.volume = this.medium.volume
        this.$refs.player.play()
      })
    },
    stop() {
      this.$refs.player.pause()
      this.$refs.player.currentTime = 0
      this.playing = false
      window.removeEventListener('keyup', this.onKeyUp)
    },
    setDuration(e) {
      this.duration = e.target.duration
    },
    timeUpdate(e) {
      this.currentTime = e.target.currentTime
    },
    onKeyUp(e) {
      if (e.which === 27) {
        this.stop()
      }
    },
    onPlay() {
      this.playing = true
      if (this.fullscreenMode) {
        this.$refs.player.webkitRequestFullscreen()
        window.addEventListener('webkitfullscreenchange', this.fullScreenChange)
      } else {
        window.addEventListener('keyup', this.onKeyUp)
      }
    },
    onEnded() {
      this.playing = false
      if (this.fullscreenMode) {
        document.webkitCancelFullScreen()
      } else {
        window.removeEventListener('keyup', this.onKeyUp)
      }
    },
    fullScreenChange() {
      if (!document.webkitFullscreenElement) {
        this.stop()
        window.removeEventListener('webkitfullscreenchange', this.fullScreenChange)
      }
    },
    toggle() {
      this.start()
    }
  },
  computed: {
    ...mapState([
      'fullscreenMode'
    ])
  }
}
</script>

<style lang="stylus" scoped>
</style>